import { debounce } from 'lodash'

const process = function (self) {
  let {
    backgroundColor,
    _croppingLeft,
    _croppingTop,
    _scaling,
    flippedHorizontally,
    flippedVertically,
    imageFormat,
    _imageWidth,
    _imageHeight,
    imageQuality,
    internalImageData,
    internalImageHeight,
    internalImageWidth,
    rotated
  } = self
  let internalImage = new Image()
  internalImage.src = internalImageData
  internalImage.crossOrigin = true
  let canvas = document.createElement('canvas')
  let context = canvas.getContext('2d')
  canvas.width = _imageWidth
  canvas.height = _imageHeight
  if (backgroundColor) {
    context.fillStyle = backgroundColor
    context.fillRect(0, 0, _imageWidth, _imageHeight)
  }
  context.translate(_croppingLeft, _croppingTop)
  context.scale(_scaling, _scaling)
  if (rotated) {
    context.translate(internalImageHeight, 0)
    context.rotate(Math.PI / 2)
  }
  if (flippedHorizontally) {
    context.translate(internalImageWidth, 0)
    context.scale(-1, 1)
  }
  if (flippedVertically) {
    context.translate(0, internalImageHeight)
    context.scale(1, -1)
  }
  context.drawImage(internalImage, 0, 0)
  if (flippedHorizontally) {
    context.translate(_imageWidth, 0)
    context.scale(-1, 1)
  }
  if (flippedVertically) {
    context.translate(0, _imageHeight)
    context.scale(1, -1)
  }
  self.imageData = canvas.toDataURL(`image/${imageFormat}`, imageQuality)
  self.$emit('update:ready', true)

  /* const mdrImage = document.getElementById('mdr_img')
  if (mdrImage) {
    mdrImage.src = self.imageData
  } else {
    const image = document.createElement('img')
    document.querySelector('.v-main__wrap')
      .prepend(image)
    image.src = self.imageData
    image.setAttribute('id', 'mdr_img')
    image.style.maxWidth = '100%'
  } */
}

const debounceProcess = debounce(
 process,
  222
)

export default function () {
  if (!this.internalImageData) {
    this.imageData = null
    this.$emit('update:ready', true)
    return
  }
  if (!this.panend) {
    return
  }
  this.$emit('update:ready', false)
  debounceProcess(this)
}
